import { Box, Container, Typography } from "@mui/material";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";

import Page from "../elements/Page";

const Terms = () => {
  return (
    <>
      <Page title="이용약관 :: Click">
        <Container sx={{ pb: 5 }}>
          <Box sx={{ my: 5 }} display="flex">
            <Typography variant="h4">클릭리스 이용약관</Typography>
          </Box>

          <ReactMarkdown remarkPlugins={[remarkBreaks, remarkGfm]}>{`
제1부 클릭리스-턱관절질환관리 서비스

제1장 총칙

제1조(목적)
본 이용약관은 클릭리스-턱관절질환관리 앱 서비스 "회원"이 비욘드메디슨이 제공하는 클릭리스-턱관절질환관리 앱 서비스(이하 "클릭리스")를 이용함에 있어 "회원"과 "회사"의 권리•의무 및 책임 사항을 규정함을 목적으로 합니다.

제2조(용어의 정의)
1. 본 약관에서 사용하는 용어의 정의는 다음과 같습니다.
- "클릭리스 서비스"란 "회사"가 "회원"의 건강과 관련된 정보의 측정과 모니터링, 관련된 정보의 제공, 관련 상담, 교육 및 관련 제3자 연계등의 다양한 지원활동을 온라인 및 오프라인에서 실시하는 것을 말합니다.
- "회원"이라 함은 "본 약관"에 동의하고 "클릭리스 서비스"를 이용하는 이용자를 말합니다.
- "ID"라 함은 "회원" 식별과 "회원"이 "클릭리스 서비스" 이용을 위하여 "회원"이 선정하고 "회사"가 승인하는 문자와 숫자의 조합을 말합니다.
- "비밀번호"라 함은 "회원"의 개인정보 보호를 위해 "회원" 이 설정하여 "회사"에 등록한 문자와 숫자의 조합을 말합니다.
- "서비스"라 함은 "클릭리스 서비스"내에서 제공하는 다양한 서비스를 통칭합니다.
- "협력의료기관" 이라 함은 서비스를 제공하기 위해 "회사"와 제휴 관계에 있는 의료기관을 협력의료기관이라 합니다.
2. "본 약관"에서 규정하지 아니한 용어는 관계 법령에서 정하는 바에 따르며, 그 외에는 상관례에 따릅니다.

제3조(클릭리스 서비스의 개요)
1. "회사"가 본 약관에 정해진 바에 따라 "회원"에게 제공하는 "클릭리스 서비스"는 아래와 같으며 이를 이용하고자 하는 고객은
본 약관에 정해진 제반 절차를 거쳐 "회원"으로 가입하여야 합니다.
① 건강정보 측정, 관리 및 모니터링
- 어플리케이션 서비스 내의 자가 기록 및 설문 조사를 이용하여 건강 정보를 수집하고 해당 수집값을 지속적으로 관리할 수 있습니다.
- 어플리케이션 서비스 내의 자가 운동 컨텐츠의 수행 여부 및 횟수에 대한 정보를 수집할 수 있습니다.
② 건강 관리 상담 및 관리
- 어플리케이션을 통해 생활습관 개선, 심리, 운동 관리 프로그램을 제공할 수 있습니다.
- 어플리케이션 사용을 고지 받은 임상연구기관(대학병원 등)을 통하여 건강관리관련 상담을
제공할 수 있습니다.
③ 정보 제공
- 어플케이션 컨텐츠, 이메일 등 온라인을 이용하여 동영상 및 멀티미디어 컨텐츠와 건강 정보 컨텐츠를 제공할 수 있습니다.
④ 제3자 연계 서비스
- "회원"의 건강과 관련된 서비스를 제3자와 연계하여 제공할 수 있습니다.
⑤ 기타 서비스
- 기타 "회원"의 건강과 관련된 다양한 서비스를 제공할 수 있습니다.
⑤ 온라인 및 오프라인 서비스
- "클릭리스 서비스"는 공히 온라인 및 오프라인으로 서비스될 수 있습니다.
⑥ 건강파트너를 통한 서비스
- "클릭리스 서비스"는 의료인, 임상연구원, 치위생사 등 관련 자격을 취득하거나 전문성을 확보한 "회사" 및 연계 회사의 인력을 통하여 제공됩니다.

2. 단, "회사"는 "회원"이 가입하는 유형에 따라 서비스 내용을 달리하여 적용합니다.

제4조(약관의 효력, 개정 및 서비스의 추가)
1. 본 약관은 제5조에서 정한 "회원"가입계약의 성립시기부터 그 효력이 발생됩니다.
2. "회사"는 합리적인 사유가 발생할 경우 다음 각 호에 규정된 방법 중 1가지 이상의 방법으로 사전 고지함으로써
본 약관을 추가, 변경할 수 있습니다. 단, "회원"의 권리 또는 의무에 관한 중요한 규정은 (i) "회사"와 "회원" 간의 사전 합의가 있거나,
또는 (ii) 법령이나 정부정책의 변경, 제품 및 서비스 제공 비용의 상당한 상승, 경영 사정의 악화 등 합리적인 사유가 있고,
이 경우에는 변경 적용일로부터 14일 전에 "클릭리스 서비스"의 웹사이트를 통한 사전 공지 및 개별적인 사전 고지가
있는 경우에 한하여 변경할 수 있습니다.
① E-mail통보
② 서면통보
③ 웹사이트(www.beyondmedicine.co.kr) 내 최소 30일 동안 게시
3. 본 조의 규정에 의하여 개정된 약관은 원칙적으로 그 효력 발생일로부터 장래를 향하여 유효합니다.
4. "회사"는 본 약관의 규정에 따라 "클릭리스 서비스"가 포함하는 다양한 추가적인 개별 서비스를 제공할 수 있습니다.
다만, 관련하여 "회원"에게 불리한 사항이 있는 경우 별도의 약관 또는 운영 원칙 등에 "회원"이 추가로 동의하는 경우에
국한하여 효력이 발생됩니다.
5. 이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 관계법령 또는 상관례에 따릅니다.

제2장 서비스 이용 계약 및 서비스 이용
제5조(회원가입)
1. "클릭리스 - 턱관절질환관리" "회원" 가입자격은 "회원" 가입 신청자가 소속된 기업 또는 "회원" 가입 신청자와 계약 관계에 있는
제휴 "회사"등(이하 "기업")의 단위로 부여되며, "기업"의 구성원의 경우 신청자가 사전에 반대의사를 표시하지 않는 한
자동으로 "회원" 가입 자격을 획득합니다.
2. "회원"가입 신청자는 본 약관이 요구하는 "회원"가입 신청 정보(또는 별도의 가입신청 양식)를 기입하여 본 약관에 동의한 후 본 약관과 별도의
'개인정보의 수집, 제공 및 활용에 관한 동의서(개인정보 처리방침)' 및 관련 양식에 동의함으로써 "회원"가입을 신청합니다.
3. "회원"가입신청이 있는 경우 "회사"는 자체 기준에 따른 심사를 거친 뒤 다음 각호에 해당하지 않는 한 "회원"가입신청 고객을 "회원"으로
등록하여 드립니다.
① 신청 시 필요사항을 허위로 기재하여 신청한 경우나 또는 오기가 있거나 허위 서류를 첨부한 경우
② 정보를 악용하거나 사회의 안녕과 질서 혹은 미풍양속을 저해할 목적으로 신청한 경우
③ 기타 "회원"으로 등록하는 것이 "회사"의 기술상 현저히 지장이 있다고 판단되는 경우
4. "회원"은 "회원"자격을 타인에게 양도하거나 대여 또는 담보의 목적으로 이용할 수 없습니다.
5. "회원"가입계약의 성립시기는 "회사"의 승낙이 가입신청자에게 도달한 시점으로 합니다.
6. "회원"은 제2항의 신청정보 기재 내용에 변경이 발생한 경우, 웹 또는 전화 등 "회사"에서 제공하는 방법을 이용하여
즉시 변경사항을 정정하여야 합니다.

제6조(‘클릭리스 – 턱관절 질환관리‘ 서비스의 이용)
1. "회원"이 클릭리스 서비스를 이용하고자 할 경우 "회사" 또는 제휴 의료기관은 "회원"에게 본인 확인을 위한 요청을 할 수 있습니다.
이 경우 "회원"은 "회사" 또는 제휴 의료기관의 요청을 준수하여야 정상적인 클릭리스 서비스를 제공 받을 수 있습니다.
2. 클릭리스 서비스는 "회원" 본인이 직접 이용하여야 하며, "회사"의 사전 동의 없이 타인에게 대여하거나 양도 또는
담보의 목적으로 이용할 수 없습니다.
3. "회원"이 웹사이트에서 사용하는 비밀번호는 "회원" 스스로의 책임하에 관리하여야 하며 "회원"의 고의 또는 과실로 도난 되거나
비밀번호가 유출되는 등의 사고(이하 "사고")가 발생한 경우 당해 "회원"은 즉시 그 사실을 "회사"에 통지하여야 합니다.

제7조(회원 자격상실/정지)
1. "회원"이 소속된 기업의 소속 자격을 상실하는 경우(퇴사 또는 고객으로서의 효력이 상실되는 경우) 자동으로
“클릭리스 서비스" "회원" 자격이 상실됩니다
2. "회원"이 다음 각 호의 사유에 해당하는 경우, "회사"는 당해 "회원"에 대한 통보로서 "회원"의 자격을 상실 또는
정지시킬 수 있습니다. 단, 제3호의 경우에는 별도의 통보 없이 당연히 자격이 상실됩니다.
① "회원" 가입 신청 시에 허위의 내용을 등록한 경우
② "클릭리스 서비스"를 부정한 방법 또는 목적으로 이용한 경우
③ "회원"이 사망한 경우
④ 다른 "회원"의 웹사이트 이용을 방해하거나 그 정보를 도용하는 등 전자거래질서를 위협하는 경우
⑤ 웹사이트를 이용하여 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우
⑥ 기타 본 약관에 규정된 "회원"의 의무를 위반한 경우
3. 본조 제2항의 사유로 자격이 상실 또는 정지된 "회원"은 제2항 각 호의 사유가 자신의 고의 또는 과실에 기한 것이
아님을 소명할 수 있습니다. 이 경우 "회사"는 "회원"의 소명 내용을 심사하여 "회원"의 주장이 타당하다고 판단하는 경우 "회원"으로 하여금
정상적인 "클릭리스 서비스"를 이용할 수 있도록 합니다.
4. 본조에 의한 "회원"자격상실 또는 "회원"자격 정지가 확정되는 시점은 "회원"자격상실 또는 "회원"자격정지 통보일로 합니다.
단, 사망으로 인한 자격상실의 경우에는 "회원" 사망일에 자격상실이 확정됩니다.

제3장 서비스 이용 계약의 해지 및 이용 제한
제8조(서비스 이용계약의 해지)
1. "회원"이 소속된 기업의 소속 자격을 상실하는 경우(퇴사 및/또는 고객으로서의 효력이 상실되는 경우),
자동으로 "클릭리스 서비스" 이용 계약은 해지됩니다.
2. "회원"이 이 약관에 의한 제반 의무를 위반한 경우 "회사"는 즉시 "회원"에 대한 이용계약을 해지할 수 있고
해지는 "회사"가 "회원"에게 해지통지를 한 즉시 효력이 발생합니다.
3. "회원"의 약관위반으로 인한 해지 시 이미 납부한 비용은 반환되지 않으며 "회원"의 의무 위반으로 인한 "회사"의 손해에 대하여는
이와 별도로 배상하여야 합니다.

제9조(웹사이트 서비스의 중단 및 서비스의 제한)
"회사"는 아래와 같은 경우 서비스의 전부 또는 일부를 제한하거나 중지할 수 있습니다.
1. 웹사이트 서비스의 중단
① "회사"의 컴퓨터 등 정보통신설비의 점검•보수•교체 및 고장, 통신의 두절 등의 사유가 발생한 경우
② 전기통신사업법에 규정된 기간통신사업자가 전기통신서비스를 중지했을 경우
③ 국가비상사태, 정전, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 정상적인 서비스 이용에 지장이 있는 경우
④ 기타 불가항력적 사유가 있는 경우
2. 클릭리스 서비스의 제한
① "회원"이 "회사"에 클릭리스 서비스 및 협력의료기관 이용에 필요한 정확한 신상정보나 자료를 제공하지 않은 경우
3. 본조 제1항의 사유로 웹사이트 서비스를 중단하고자 할 경우 "회사"는 E-mail로 발송하거나 웹사이트에 게시하는 방법으로
"회원"에게 웹사이트 서비스의 중단사실을 알려드립니다.

제4장 정보의 관리
제10조(회원의 게시물)
1. 게시물이라 함은 웹사이트 내에 "회원"이 올린 글, 사진, 그림, 각종 파일과 링크, 각종 댓글 등의 정보를 의미합니다.
2. "회원"이 웹사이트 내에 게시한 게시물로 인해 "회원" 개인에게 발생하는 손실이나 문제는 "회원" 개인의 책임이므로,
게시물 작성 시 관련법령에 위배되지 않도록 유의해야 합니다.
3. "회원"은 다음 각 호에 해당하는 게시물을 게시하거나 전달할 수 없으며 "회사"는 웹사이트 내에 존재하는 게시물이
다음 각 호에 해당한다고 판단되는 경우 해당 게시물을 삭제, 이동 또는 등록거부 할 수 있습니다. 또한, "회사"는 게시물에 관련된
세부 이용지침을 별도로 정하여 시행할 수 있으며, "회원"은 그 지침에 따라 각종 게시물을 등록하거나 삭제하여야 합니다.
① 다른 "회원" 또는 제3자를 비방하거나 명예를 손상시키는 내용인 경우
② 공공질서 및 공서양속에 위반되는 내용을 유포하는 경우
③ 범죄적 행위에 결부된다고 인정되는 내용인 경우
④ "회사"의 저작권, 제3자의 저작권 등 기타 권리를 침해하는 내용인 경우
⑤ 법령을 위반하거나 타인의 권리를 침해하는 방식으로 정치적, 종교적 분쟁을 야기하는 경우
⑥ 불필요하거나 승인되지 않은 광고, 판촉물을 게재하는 경우
⑦ 타인의 개인정보를 도용하여 작성한 내용이거나, 타인이 입력한 정보를 무단으로 위•변조한 내용인 경우
⑧ 동일한 내용을 중복하여 다수 게시하는 등 게시의 목적에 어긋나는 경우
⑨ 기타 관계 법령 및 "회사"의 지침 등에 위반된다고 판단되는 경우

제11조(게시물의 저작권)
1. "회원"이 웹사이트 내에 게시한 게시물 등으로 인하여 본인 또는 타인에게 손해나 기타 문제가 발생하는 경우
"회원"은 이에 대한 책임을 지게되며, "회사"는 특별한 사정이 없는 한 이에 대하여 책임을 지지 않습니다.
2. "회사"가 작성한 저작물에 대한 저작권 기타 지적재산권은 "회사"에 귀속되며, "회원"은 웹사이트를 이용하여
얻은 정보를 "회사"의 사전 승낙없이 복제, 송신, 출판, 배포, 방송, 가공, 판매하는 행위 등 서비스 내에 게재된 자료를 상업적으로 이용하거나
제3자에게 이용하게 하여서는 안됩니다.
3. "회원"은 자신이 게시한 게시물을 "회사"가 국내외에서 다음 각 호의 목적으로 사용하는 것을 허락합니다.
① 웹사이트 내에서 "회원" 게시물의 복제, 전송, 전시, 배포 및 우수 게시물을 서비스 화면에 노출하기 위하여
"회원" 게시물의 크기를 변화하거나 단순화하는 등의 방식으로 수정하는 것
② "회사"가 운영하는 관련 사이트의 서비스 내에서 "회원" 게시물을 전시•배포하는 것. 단 "회원"이 전시•배포에 대하여 반대의 의사를 "회사"에게
통지할 경우 그 이후부터 "회사"는 관련 사이트의 서비스 내에서 당해 "회원"의 게시물을 전시•배포하지 않습니다.
③ "회사"를 홍보하기 위한 목적으로 미디어, 통신사 등에게 이용자의 게시물 내용을 보도•방영하게 하는 것. 단 이 경우 게시물 내용이
회원의 신상정보가 노출되고 회원의 명예를 손상시킬 우려가 있는 경우라면 "회사"는 "회원"으로부터 보도•방영에 대한 사전 동의를
득하기로 합니다.
4 . "회사"는 "회사"의 합병, 영업양도, "회사"가 운영하는 사이트간의 통합 등의 사유로 원래의 게시물의 내용을 변경하지 않고
게시물의 게시위치를 변경할 수 있습니다.
5. "회원"은 웹사이트를 이용함으로써 얻은 정보를 "회사"의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여
영리목적으로 이용하여서는 안됩니다.

제12조(개인정보보호)
1. "회사"는 관련법령 및 "회사"가 정하는 개인정보처리방침이 정하는 바에 따라서 "회원"정보를 포함한 이용자의 개인정보를
보호하기 위하여 노력합니다.
2. "회사"는 개인정보 보호에 대한 상세한 내용을 "개인정보처리방침"에 명시하고 있으며, "회원"이 상시 확인할 수 있도록
웹사이트를 통해 공지합니다.
3. "회사"는 이용자의 개인 정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 개인정보관리 책임자를 지정하고 있습니다.
다만, 개인정보 관리책임자/관리담당자는 "회사"의 사정에 따라 변경될 수 있습니다.
4. "개인정보처리방침"이 변경될 경우 관련 법령에 따른 통지방법에 따라 변경사항을 "회원"에게 알려드립니다.

제5장 서비스에 대한 책임의 제한
제13조 (상담, 각종 기록의 관리와 책임제한)
1. "회사"는 '개인정보처리방침'에 명시되어 있는 모든 방법을 이용해 "회원"의 건강기록이나 상담내용이 "회사"에서 지정하지 않은
제3자에게 유출되지 않도록 최선을 다해 보안을 유지하려고 노력합니다. 단, "회원"이 신청한 상담에 대한 종합적이고 적절한 답변을 위하여
"회원"의 동의 하에 당사의 담당직원은 상담내용과 답변을 참고할 수 있습니다.
2. 클릭리스 서비스의 제공을 위하여 필요한 경우 건강파트너는 "회원"의 건강기록과 상담내용을 참고할 수 있고, "회원"은 위 정보가
"회원"의 자의에 따라 자발적으로 제공하거나 공개한 것임을 긍정합니다.
3. "회원"은 상담 신청시 효율적인 답변을 위하여 "회원"의 신체 건강 현황정보를 "회사"에 제공하거나 공개할 수 있고, "회원"은 위 정보가
"회원"의 자의에 따라 자발적으로 제공하거나 공개한 것임을 긍정합니다. 그리고 "회사"는 "회원"으로부터 위 정보를 기초로
신청된 상담에 대해 답변할 수 있습니다.
4. 서비스에서 진행된 상담의 내용은 개인 신상정보를 삭제한 다음 FAQ, 상담사례집과 같이 원활한 상담을 목적으로 사용할 수 있습니다.
5. 서비스에서 제공되는 상담은 결코 의학적 진단, 진료, 혹은 치료를 대신하려는 목적이 아닙니다. "회원"의 건강상태에 관한 의문점이나
걱정이 있다면 실제 전문의사를 찾아 진단을 받아야 합니다. 따라서, 건강상담에 대한 답변 내용은 각 전문 상담사의 의학적 지식을
바탕으로 한 주관적인 답변으로 "회사"의 공식적인 의견이 될 수 없으며, 상담내용에 대하여 "회사"는 일체의 책임을 지지 않습니다.
6. 서비스 과정에서 제공되는 건강종합평가, 건강관리와 관련된 과제, 건강관리와 관련된 제안 및 정보 등은 의학적인 일반적 권고사항에
불과한 것으로 개인의 건강상태에 따라 달라질 수 있으며 이 내용의 활용여부는 전적으로 "회원"의 판단에 따르는 것으로
"회사"는 이에 대하여 어떠한 책임도 지지 않습니다.
7. 다음 각호와 같은 상담을 신청하는 경우에는 상담 서비스의 전체 또는 일부를 제공하지 않을 수 있습니다.
① 같은 내용의 상담을 반복 신청하는 경우
② 상식에 어긋나는 표현을 사용하여 상담을 신청하는 경우
③ 진단명을 요구하는 상담을 신청하는 경우
④ 치료비, 검사비, 의약품 가격 등에 대하여 상담을 신청하는 경우
⑤ 기타 의료법 등 관계 법령에 저촉되는 상담을 신청하는 경우

제14조 (건강 관련 콘텐츠와 책임제한)
1. "회사"에서 제공되는 건강 관련 콘텐츠는 개략적이며 일반적인 내용으로써, 특정인의 의견에 지나지 않으며 어떠한 경우라도
의학적 진단, 진료 혹은 치료를 대신할 수 없습니다.
2. "회사"는 건강 관련 콘텐츠에서 언급된 어떠한 특정한 검사나 제품 혹은 치료법도 추천하지 않습니다.
3. "회사"에서 제공하는 건강관련정보는 전적으로 이용자의 판단에 따라 이용되는 것으로서,
"회사"는 건강 관련 콘텐츠의 제공과 관련하여 어떠한 책임도 지지 않습니다.

제15조("회원"의 의무)
"회원"은 웹사이트 이용과 관련하여 다음 각 호의 행위를 하여서는 안됩니다.
① 웹사이트 이용 관련 제반 신청행위 또는 변경행위시 허위내용 기재행위
② 웹사이트에 게시된 각종 정보의 무단 변경, 삭제 등 훼손 행위
③ 웹사이트가 허용한 정보 이외의 다른 정보(컴퓨터 프로그램 및 광고 등)를 송신하거나 게시하는 행위
④ "회사" 및 기타 제3자의 저작권 등 지적재산권에 대한 침해 행위
⑤ "회사" 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위
⑥ 외설 또는 폭력적인 정보(메시지•화상•음성 등), 기타 공서양속에 반하는 정보를 웹사이트에 공개하거나 게시하는 행위

제16조("회원" 정보 보안 의무)
1. "클릭리스 서비스" 앱은 "회원"만 이용할 수 있습니다.
2. 앱 서비스를 이용하고자 하는 "회원"은 "회사"가 정하는 바에 따라 아이디 및 비밀번호를 등록하여야 합니다.
3. 아이디와 비밀번호에 관한 관리책임은 "회원" 본인에게 있으므로 "회원"은 자신의 아이디 및 비밀번호를 제3자에게 알려주거나
이용하게 해서는 안됩니다.
4. "회원"이 자신의 아이디 또는 비밀번호를 도난 당하거나 제3자가 사용하고 있음을 인지한 경우에는 즉시 "회사"에 통보하고
"회사"의 안내가 있는 경우에는 그에 따라야 합니다.

제17조(광고게재 및 광고주와의 거래)
1. "회사"는 웹사이트, e-mail, 서신 등에 광고를 게재할 수 있습니다. "회원"은 서비스 이용 시 노출되는 광고게재에 대해
동의하는 것으로 간주됩니다.
2. 광고주에 의해 게재된 광고내용이나 판촉활동에 대하여 "회원"은 본인의 책임과 판단으로 참여하거나 교신 또는 거래하여야 하며,
그 결과로서 발생하는 모든 손실 또는 손해에 대해 "회사"는 책임을 지지 않는 것을 원칙으로 합니다.

제3부 면책 사항 및 기타
제1조(손해배상)
1. "회사"는 "클릭리스 서비스" 이용과 관련하여 "회원"에게 발생한 손해에 대하여 "회사"의 고의 또는 과실에 의한 위법행위로 인하여 발생한 경우가 아닌 한 책임을 지지 않습니다.
2. "회원"은 이 약관의 규정을 위반함으로 인하여 "회사"나 "회원" 또는 제3자에 대하여 책임을 부담하게 되고, 이로써 "회사"에 손해가 발생하는
경우, 이 약관을 위반한 "회원"은 "회사"에게 발생하는 모든 손해를 배상하여야 하며, 동 손해로부터 "회사"를 면책시켜야 합니다.

제2조(면책조항)
1. "회사"는 천재지변 및 이에 준하는 불가항력으로 인한 경우 또는 본 약관 1부 제9조 제1항의 사유로 "클릭리스 서비스"를
일시적으로 중단하는 경우 "회사"는 이로 인하여 "회원" 또는 제3자가 입은 손해에 대하여 책임지지 않습니다.
단, "회사"의 고의 또는 중과실로 인한 경우에는 그러하지 아니합니다.
2. "회사"는 "회원"의 귀책사유로 인한 "클릭리스 서비스" 이용의 장애에 대하여 책임을 지지 않습니다.
3. "회원"이 자신의 개인정보를 타인에게 유출 또는 제공함으로써, 발생하는 피해에 대해서 "회사"는 일체의 책임을 지지 않습니다.
4. "회사"는 "회원"이 "클릭리스 서비스"를 이용하여 기대하는 손익이나 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다.
5. "회사"는 "회원"이 웹사이트에 게재한 정보, 자료, 사실의 신뢰도, 정확성 등 내용에 관하여는 책임을 지지 않습니다.
6. "회원"이 이 약관의 규정을 위반함으로 인하여 "회사"나 "회원" 또는 제3자에 대하여 책임을 부담하게 되고, 이로써 "회사"에게
손해가 발생하는 경우, 이 약관을 위반한 "회원"은 "회사"에게 발생하는 모든 손해를 배상하여야 하며,
동 손해로부터 "회사"를 면책시켜야 합니다.

제3조(분쟁의 해결)
1. "회사"와 "회원"은 "클릭리스 서비스"와 관련하여 발생한 분쟁을 원활하게 해결하기 위하여 필요한 모든 노력을 합니다.
2. "회사"는 "클릭리스 서비스" 이용과 관련하여 "회원"으로부터 제출되는 불만사항 및 의견을 최대한 신속하게 처리합니다.
다만, 신속한 처리가 곤란한 경우에는 "회원"에게 그 사유와 처리일정을 조속히 통보해 드립니다.
3. "회사"와 "회원"간에 발생한 분쟁은 분쟁과 관련하여 이용자의 피해구제신청이 있는 경우에는 공정거래위원회 또는
시•도지사가 의뢰하는 분쟁조정기관의 조정에 따를 수 있습니다.

제4조(준거법 및 합의관할)
1. 본 약관에서 정하지 않은 사항과 본 약관의 해석에 관하여는 대한민국법 및 상관례에 따릅니다.
2. "클릭리스 서비스" 이용으로 발생한 분쟁에 관한 소송은 민사소송법상의 관할 소재지 법원 또는 당사자들이
별도로 합의한 법원을 관할 법원으로 합니다.

제5조(서비스 별 약관)
"클릭리스 서비스" 및 추가적인 서비스의 이용을 위하여 이용약관 이외의 별도의 약관(또는 공지)이 존재할 수 있으며,
별도의 약관과 "회사" 이용약관의 내용이 상충될 경우 해당 서비스와 가장 인접한 약관이 우선됩니다.

`}</ReactMarkdown>
        </Container>
      </Page>
    </>
  );
};

export default Terms;